// ▼fadeスクロールアニメーション
function scrollFadeAnimation() {
  const targetElement = document.querySelectorAll(".animation");
  if (!targetElement) {
    return false;
  }
  const fadeOption = {
    root: null, // null の場合はデフォルトで、ブラウザのビューポートが使用される
    rootMargin: "-10% 0px", // ターゲットがビューポートに見えているかどうかを判断するための範囲を拡大、縮小できます
    threshold: 0, // 指定した要素が画面に何%入っているかでコールバックイベントを発生させるか指定できる。0から1.0までを指定
  };
  const targets = (entries, observer) => {
    entries.forEach((entry) => {
      //isIntersectingプロパティは交差しているかどうかのブール値
      if (entry.isIntersecting) {
        entry.target.classList.add("is-scroll-active");
        observer.unobserve(entry.target);
      }
    });
  };
  const fadeObserver = new IntersectionObserver(targets, fadeOption);

  // 監視したい要素を入力 複数あるので繰り返し処理をしている
  targetElement.forEach((target) => {
    fadeObserver.observe(target);
  });
}
scrollFadeAnimation();
